import useSWRMutation from "swr/mutation";
import { postFetcher } from "@/lib/swr";
import { useToast } from "@/hooks/use-toast";
import { toastError } from "@/lib/toast";
import type { Prd } from "@/types/domain";

// 放回需求池 / 下车 (versionId → NULL, relation row kept): the one shared
// POST /prds/:id/unschedule mutation behind every unschedule control. Callers pass the
// revalidation for their view; failures surface a toast.
// `onSuccess` receives the echoed PRD (the service returns the work item's
// detail) so callers can write it back instead of refetching (WED-249).
export const useUnschedule = (onSuccess: (saved: Prd) => void) => {
  const { toast } = useToast();
  const { trigger, isMutating } = useSWRMutation("/prds/unschedule", (_key: string, { arg }: { arg: string }) =>
    postFetcher<Prd>(`/prds/${arg}/unschedule`, { arg: {} }), {
    onSuccess,
    onError: (err: unknown) =>
      toastError(toast, "下车失败", err, "Unschedule failed"),
  });
  return { unschedule: trigger, unscheduling: isMutating };
};
